import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';

import { useFetchVideoCompilations } from '@src/hooks';
import { formatDateMmDdYyyy } from '@src/utils';
import { StyledTableRow } from '@vp-ui/widgets/VpVideoCompilationTable/styles';
import VpVideoCompilationInfoMenu from '@vp-ui/widgets/VpVideoCompilationTable/VpVideoCompilationsInfoMenu';
import { getIsOrganizationViewer } from '@src/redux/modules/organization';
import VideoCompilationPageSwitch from '@vp-ui/widgets/VpVideoCompilationTable/VideoCompilationPageSwitch';

const VpVideoCompilationsTableBodyInner = ({ history, isOrgViewer }) => {
  const { data } = useFetchVideoCompilations();
  const videoCompilationList = data?.records;

  const handleRowClick = (pageLink) => {
    history.push(`/libraries/${pageLink}`);
  };

  return (
    <TableBody>
      {videoCompilationList?.map((videoCompilation) => (
        <StyledTableRow
          hover
          key={videoCompilation?.id}
          onClick={() => handleRowClick(videoCompilation?.pageLink)}
        >
          <TableCell>
            <VideoCompilationPageSwitch
              enabled={videoCompilation?.enabled}
              data={videoCompilation}
              disabled={isOrgViewer}
            />
          </TableCell>
          <TableCell>{videoCompilation?.title}</TableCell>
          <TableCell>{videoCompilation?.mediaCount ?? videoCompilation?.media?.length ?? 0}</TableCell>
          <TableCell>{videoCompilation?.linkClicks}</TableCell>
          <TableCell>{formatDateMmDdYyyy(videoCompilation.createdAt)}</TableCell>
          <TableCell padding="checkbox">
            {!isOrgViewer && (
              <VpVideoCompilationInfoMenu
                vcpId={videoCompilation?.id}
                pageLink={videoCompilation?.pageLink}
              />
            )}
          </TableCell>
        </StyledTableRow>
      ))}
    </TableBody>
  );
};

VpVideoCompilationsTableBodyInner.propTypes = {
  history: PropTypes.shape({ push: PropTypes.func.isRequired }).isRequired,
  isOrgViewer: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isOrgViewer: getIsOrganizationViewer(state)
});

export const VpVideoCompilationsTableBody = withRouter(connect(mapStateToProps)(VpVideoCompilationsTableBodyInner));
export default VpVideoCompilationsTableBody;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpVideoCompilationTable/VpVideoCompilationsTableBody.jsx